const SET_ANIMALS = (state, payload) => {
  state.animalsReleased = payload;
}
const SET_ALL_ANIMALS = () => {
}
const SET_HEADQUARTERS = (state, payload) => {
  state.headquarters = payload;
}
const SET_NEW_EDIT = (state, payload) => {
  state.animalsBirth.forEach(e => {
    if(e.id === payload.id) {
      e = payload;
    }
  });
}
const SET_NEW_BIRTH = (state, payload) => {
  state.animalsBirth.push(payload);
}
const SET_ANIMALS_BIRTH = (state, payload) => {
  state.animalsBirth = payload;
}
const SET_BIRTH_PAGINATION = (state, payload) => {
  state.birth_pagination = payload;
}
const SET_REGIMES = (state, payload) => {
  state.regimes = payload;
}
const SET_EXPLANATIONS = (state, payload) => {
  const result = Object.entries(payload).map(([name, value]) => {
    const label = value === 12 ? "Bezerro ao pé" : value === 13 ? "Em lactação" : name;
    return {title:value + " - " + label, name:label, id:value.toString()};
  });
  if(!result.some(item => item.id === "13")) {
    result.push({title:"13 - Em lactação", name:"Em lactação", id:"13"});
  }
  state.explanations = result;
}
const SET_DOWNS_REASON = (state, payload) => {
  const keys = Object.keys(payload);
  const values = Object.values(payload);
  const result = [];
  keys.forEach((item, index) => {
    values.forEach((val,i) => {
      if(index === i) {
        result.push({name:item, id:val});
      }
    });
  });
  state.down_reasons = result;
}
const SET_CLOSURE = (state, payload) => {
  const keys = Object.keys(payload);
  const values = Object.values(payload);
  const result = [];
  keys.forEach((item, index) => {
    values.forEach((val,i) => {
      if(index === i) {
        result.push({name:item, id:val});
      }
    });
  });
  state.closure_reasons = result;
}
const SET_BIRTH_PRODUCTION_INFO = (state, payload) => {
  state.birth_production_info = payload;
}
const SET_ANIMALS_KILLED = (state, payload) => {
  state.kill_list = payload;
}
const SET_KILLS_PAGINATION = (state, payload) => {
  state.kills_pagination = payload;
}
const SET_NEW_ANIMAL = (state, payload) => {
  state.animals.unshift(payload);
}
export default {
  SET_ANIMALS,
  SET_ALL_ANIMALS,
  SET_HEADQUARTERS,
  SET_NEW_BIRTH,
  SET_NEW_EDIT,
  SET_ANIMALS_BIRTH,
  SET_BIRTH_PAGINATION,
  SET_REGIMES,
  SET_EXPLANATIONS,
  SET_DOWNS_REASON,
  SET_CLOSURE,
  SET_BIRTH_PRODUCTION_INFO,
  SET_ANIMALS_KILLED,
  SET_KILLS_PAGINATION,
  SET_NEW_ANIMAL
}
